import { render, staticRenderFns } from "./optional.vue?vue&type=template&id=b858f308&scoped=true"
import script from "./optional.vue?vue&type=script&lang=js"
export * from "./optional.vue?vue&type=script&lang=js"
import style0 from "./optional.vue?vue&type=style&index=0&id=b858f308&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b858f308",
  null
  
)

export default component.exports